import PasswordRecoverySuccess from "./PasswordRecoverySuccess";

export default PasswordRecoverySuccess;
